var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"physical-exercise-edit-form"},[_c('physical-exercise-base-form',{attrs:{"initial-data":_vm.exercise,"is-edit":""},on:{"submit":_vm.handleSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }